export default __webpack_public_path__ + "static/media/Associate_FAQ.168ed7de.pdf";